




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FooterComponent from '@/components/footer.component.vue';
import AuthenticationModule from '@/store/modules/authentication.module';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AuthenticationActions } from '@/constants/actions.constants';
import { mapState, mapGetters } from 'vuex';
import { routeName } from '@/constants/route.constants';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FooterComponent
  },
  computed: {
    token(): string | (string | null)[] {
      return this.$route.query.token;
    },
    email(): string | (string | null)[] {
      return this.$route.query.email;
    },
    ...mapState('authentication', ['showButtonLoading']),
    ...mapGetters('authentication', ['hasErrorMessages', 'errorMessages'])
  }
})
export default class ResetPasswordFormComponent extends Vue {
  public showButtonLoading!: boolean;
  public hasErrorMessages!: boolean;
  public errorMessages!: Array<string>;
  public token: string | (string | null)[];
  public email: string | (string | null)[];
  public password = '';
  public confirmPassword = '';

  public $refs: {
    form: HTMLFormElement;
  };

  @Watch('hasErrorMessages')
  private onHasErrorMessagesChanged(value: boolean) {
    if (value) {
      return this.$toasted.error(this.errorMessages.join());
    }
  }

  public async onSaveClick() {
    const success: boolean = await this.$refs.form.validate();

    if (!success || !this.email || !this.token) {
      return;
    }

    const authenticationModule: AuthenticationModule = getModule(
      AuthenticationModule,
      store
    );

    await authenticationModule[AuthenticationActions.resetPasswordAction]({
      email: this.email as string,
      password: this.password,
      confirmPassword: this.confirmPassword,
      token: this.token as string
    });

    if (!this.hasErrorMessages) {
      this.$toasted.success('Password reset successfully.');

      await this.$router.replace({ name: routeName.login });
    }
  }
}
